import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'tramites/archivos-de-comentarios-de-tramites/';

/**
 * GET Archivos De Tramites
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getArchivosDeComentariosDeTramites = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Archivos De Tramites
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getArchivosDeComentariosDeTramitesPorIdsComentario = async (idsComentarios) => {
  try {
    const response = await Promise.all(idsComentarios
      .map((comentario) => getArchivosDeComentariosDeTramites({ comentario })));
    return response.flat();
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Archivo De Comentario De Tramite
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getArchivoDeComentarioDeTramite = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

const formatFileValues = (_values) => {
  if (_values.archivo) {
    const values = { ..._values };
    const formData = new FormData();
    const valuesKeys = Object.keys(values);
    valuesKeys.forEach((key) => {
      formData.append(`${key}`, values[key] || '');
    });
    formData.append('tamanio', (values.archivo.size / 1024 / 1024).toFixed(2));
    formData.append('extension_del_documento', values.archivo.name.split('.').pop().toLowerCase());

    const _config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return [formData, _config];
  }
  return [_values];
};

/**
 * POST Archivo De Comentario De Tramite
  * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const postArchivoDeComentarioDeTramite = async (_values) => {
  try {
    const [values, config] = formatFileValues(_values);
    const response = await API.post(baseURI, values, config);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Archivo De Comentario De Tramite
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchArchivoDeComentarioDeTramite = async (id, _values) => {
  try {
    const [values, config] = formatFileValues(_values);
    const response = await API.patch(`${baseURI}${id}`, values, config);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Archivo De Comentario De Tramite
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteArchivoDeComentarioDeTramite = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
